import styled from '@emotion/styled'

export const StyledA = styled.a`
  color: ${(props) => props.theme.palette.grey[800]};
  cursor: pointer;
  text-decoration: none;
  transition: color .2s ease-in-out;
  
  &:hover {
    color: ${(props) => props.theme.palette.info.dark};
  }
`
